export class FuseAnimationCurves {
    public static readonly standard = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
    public static readonly deceleration = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
    public static readonly acceleration = 'cubic-bezier(0.4, 0.0, 1, 1)';
    public static readonly sharp = 'cubic-bezier(0.4, 0.0, 0.6, 1)';
}

export class FuseAnimationDurations {
    public static readonly complex = '375ms';
    public static readonly entering = '225ms';
    public static readonly exiting = '195ms';
}
